import { create } from 'zustand'
import { TwitterPost } from '../types/twitterPost'
import { Pagination } from '../types/pagination'

export interface WebSourceLink {
    id: string
    content: string
    link: string
    title?: string
}

export interface RelatedQuestionsType {
    link: string
    question: string
    title: string
    snippet: string
}

export interface DiscordMessageProps {
    id: string
    author_url: string
    author: string
    date: Date
    content: string
    replies: DiscordMessageProps[]
    possible_replies: DiscordMessageProps[]
    channel: string
    link: string
}

export interface PostSlice {
    posts: TwitterPost[]
    links: WebSourceLink[]
    discordMessages: DiscordMessageProps[]
    images: string[]
    searchQueries: string[]
    videos: []
    questions: RelatedQuestionsType[]
    pagination: Pagination
    search: string | null
    loading: boolean
    error: unknown
    setPosts: (newPosts: TwitterPost[]) => void
    setSearch: (query: string | null) => void
    setLinks(links: WebSourceLink[]): void
    setImages: (images: string[]) => void
    setVideos: (videos: any) => void
    setRelatedQuestions: (questions: RelatedQuestionsType[]) => void
    setRelatedSearches: (searchQueries: string[]) => void
    setDiscordMessages: (discordMessages: DiscordMessageProps[]) => void
}

export const postSlice = create<PostSlice>((set, get) => ({
    posts: [],
    links: [],
    images: [],
    videos: [],
    discordMessages: [],
    searchQueries: [],
    questions: [],
    pagination: {
        totalPages: 0,
        currentPage: 0,
        nextPage: true,
    },
    search: null,
    loading: false,
    error: '',
    setPosts: (newPosts: TwitterPost[]) => {
        set(state => ({ ...state, posts: newPosts }))
    },
    setSearch: async (query: string | null) => {
        set({
            search: query,
            pagination: {
                ...get().pagination,
                currentPage: 0,
                nextPage: true,
            },
            error: '',
            loading: true,
            posts: [],
            links: [],
        })
    },
    setLinks(newLinks: WebSourceLink[]) {
        set(state => ({ ...state, links: [...state.links, ...newLinks] }))
    },
    setImages(newImages: string[]) {
        set(state => ({ ...state, images: [...newImages] }))
    },
    setVideos(videos: any) {
        set(state => ({ ...state, videos: videos }))
    },
    setRelatedQuestions(questions: RelatedQuestionsType[]) {
        set(state => ({ ...state, questions: questions }))
    },
    setRelatedSearches(searchQueries: string[]) {
        set(state => ({ ...state, searchQueries: searchQueries }))
    },
    setDiscordMessages(discordMessages: DiscordMessageProps[]) {
        set(state => ({ ...state, discordMessages: discordMessages }))
    },
}))
